export function getNewOrder(list, order = 0) {
  for(var i = 0; i < list.length; i++) {
    if(list[i].order == order) {
      return getNewOrder(list, order + 1)
    }
  }
  return order;
}

// TODO ?
export function reorderList(state) {
  var list = getFunctionsOfType(state, triggerId)
  list = list.sort((a, b) => a.order-b.order);

  return state.map(func => {
    if(func.triggerId == triggerId
      && func.functionType == functionType) {
      for(var i = 0; i < list.length; i++) {
        if(list[i].id == func.id)
          return {...func, order:i}
      }
    }
    return func;
  });
}